// removed by extract-text-webpack-plugin
module.exports = {"loaderText":"loaderText__1O_cR","buttonOpacity":"buttonOpacity__1tG6R"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/requestButton/style.css
// module id = uRp7
// module chunks = 323